// services/productService.js
import { apiService } from './api';

// ---------- Product Service ----------
export const productService = {
  getCategoriesWithProducts: async () => {
    try {
      const response = await apiService.getCategoriesWithProducts();

      if (Array.isArray(response)) return response;
      if (response && response.data) return response.data;
      if (response && response.success) return response.data || [];

      return [];
    } catch (error) {
      console.error('Error in getCategoriesWithProducts:', error);
      throw error;
    }
  },

  getProductById: async (id) => {
    try {
      const response = await apiService.getProductById(id);
      if (response.success) return response.data;
      throw new Error(response.error || 'Produit non trouvé');
    } catch (error) {
      console.error('Error in getProductById:', error);
      throw error;
    }
  },

  getFeaturedProducts: async () => {
    try {
      const response = await apiService.getFeaturedProducts();
      if (response.success) return response.data;
      return [];
    } catch (error) {
      console.error('Error in getFeaturedProducts:', error);
      throw error;
    }
  },

  getProductsByGender: async (gender) => {
    try {
      const response = await apiService.getProductsByGender(gender);
      if (response.success) return response.data;
      return [];
    } catch (error) {
      console.error('Error in getProductsByGender:', error);
      throw error;
    }
  },

  searchProducts: async (query) => {
    try {
      // ✅ Utilise API_BASE_URL pour que ça fonctionne en prod et local
      const response = await apiService.apiRequest(`/products/search.php?q=${encodeURIComponent(query)}`);
      if (response.success) return response.data || [];
      return [];
    } catch (error) {
      console.error('Search error:', error);
      return [];
    }
  },
};

// Export direct pour simplifier les imports
export const {
  getCategoriesWithProducts,
  getProductById,
  getFeaturedProducts,
  getProductsByGender,
  searchProducts
} = productService;
